import { render } from "./ModuleSidebar.vue?vue&type=template&id=b0cc21a6"
import script from "./ModuleSidebar.vue?vue&type=script&lang=js"
export * from "./ModuleSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__